/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import { __assign } from "tslib";
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/largePersonGroupPersonMappers";
import * as Parameters from "../models/parameters";
/** Class representing a LargePersonGroupPerson. */
var LargePersonGroupPerson = /** @class */ (function () {
    /**
     * Create a LargePersonGroupPerson.
     * @param {FaceClientContext} client Reference to the service client.
     */
    function LargePersonGroupPerson(client) {
        this.client = client;
    }
    LargePersonGroupPerson.prototype.create = function (largePersonGroupId, options, callback) {
        return this.client.sendOperationRequest({
            largePersonGroupId: largePersonGroupId,
            options: options
        }, createOperationSpec, callback);
    };
    LargePersonGroupPerson.prototype.list = function (largePersonGroupId, options, callback) {
        return this.client.sendOperationRequest({
            largePersonGroupId: largePersonGroupId,
            options: options
        }, listOperationSpec, callback);
    };
    LargePersonGroupPerson.prototype.deleteMethod = function (largePersonGroupId, personId, options, callback) {
        return this.client.sendOperationRequest({
            largePersonGroupId: largePersonGroupId,
            personId: personId,
            options: options
        }, deleteMethodOperationSpec, callback);
    };
    LargePersonGroupPerson.prototype.get = function (largePersonGroupId, personId, options, callback) {
        return this.client.sendOperationRequest({
            largePersonGroupId: largePersonGroupId,
            personId: personId,
            options: options
        }, getOperationSpec, callback);
    };
    LargePersonGroupPerson.prototype.update = function (largePersonGroupId, personId, options, callback) {
        return this.client.sendOperationRequest({
            largePersonGroupId: largePersonGroupId,
            personId: personId,
            options: options
        }, updateOperationSpec, callback);
    };
    LargePersonGroupPerson.prototype.deleteFace = function (largePersonGroupId, personId, persistedFaceId, options, callback) {
        return this.client.sendOperationRequest({
            largePersonGroupId: largePersonGroupId,
            personId: personId,
            persistedFaceId: persistedFaceId,
            options: options
        }, deleteFaceOperationSpec, callback);
    };
    LargePersonGroupPerson.prototype.getFace = function (largePersonGroupId, personId, persistedFaceId, options, callback) {
        return this.client.sendOperationRequest({
            largePersonGroupId: largePersonGroupId,
            personId: personId,
            persistedFaceId: persistedFaceId,
            options: options
        }, getFaceOperationSpec, callback);
    };
    LargePersonGroupPerson.prototype.updateFace = function (largePersonGroupId, personId, persistedFaceId, options, callback) {
        return this.client.sendOperationRequest({
            largePersonGroupId: largePersonGroupId,
            personId: personId,
            persistedFaceId: persistedFaceId,
            options: options
        }, updateFaceOperationSpec, callback);
    };
    LargePersonGroupPerson.prototype.addFaceFromUrl = function (largePersonGroupId, personId, url, options, callback) {
        return this.client.sendOperationRequest({
            largePersonGroupId: largePersonGroupId,
            personId: personId,
            url: url,
            options: options
        }, addFaceFromUrlOperationSpec, callback);
    };
    LargePersonGroupPerson.prototype.addFaceFromStream = function (largePersonGroupId, personId, image, options, callback) {
        return this.client.sendOperationRequest({
            largePersonGroupId: largePersonGroupId,
            personId: personId,
            image: image,
            options: options
        }, addFaceFromStreamOperationSpec, callback);
    };
    return LargePersonGroupPerson;
}());
export { LargePersonGroupPerson };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var createOperationSpec = {
    httpMethod: "POST",
    path: "largepersongroups/{largePersonGroupId}/persons",
    urlParameters: [
        Parameters.endpoint,
        Parameters.largePersonGroupId
    ],
    requestBody: {
        parameterPath: {
            name: [
                "options",
                "name"
            ],
            userData: [
                "options",
                "userData"
            ]
        },
        mapper: __assign(__assign({}, Mappers.NameAndUserDataContract), { required: true })
    },
    responses: {
        200: {
            bodyMapper: Mappers.Person
        },
        default: {
            bodyMapper: Mappers.APIError
        }
    },
    serializer: serializer
};
var listOperationSpec = {
    httpMethod: "GET",
    path: "largepersongroups/{largePersonGroupId}/persons",
    urlParameters: [
        Parameters.endpoint,
        Parameters.largePersonGroupId
    ],
    queryParameters: [
        Parameters.start0,
        Parameters.top0
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "Person"
                        }
                    }
                }
            }
        },
        default: {
            bodyMapper: Mappers.APIError
        }
    },
    serializer: serializer
};
var deleteMethodOperationSpec = {
    httpMethod: "DELETE",
    path: "largepersongroups/{largePersonGroupId}/persons/{personId}",
    urlParameters: [
        Parameters.endpoint,
        Parameters.largePersonGroupId,
        Parameters.personId
    ],
    responses: {
        200: {},
        default: {
            bodyMapper: Mappers.APIError
        }
    },
    serializer: serializer
};
var getOperationSpec = {
    httpMethod: "GET",
    path: "largepersongroups/{largePersonGroupId}/persons/{personId}",
    urlParameters: [
        Parameters.endpoint,
        Parameters.largePersonGroupId,
        Parameters.personId
    ],
    responses: {
        200: {
            bodyMapper: Mappers.Person
        },
        default: {
            bodyMapper: Mappers.APIError
        }
    },
    serializer: serializer
};
var updateOperationSpec = {
    httpMethod: "PATCH",
    path: "largepersongroups/{largePersonGroupId}/persons/{personId}",
    urlParameters: [
        Parameters.endpoint,
        Parameters.largePersonGroupId,
        Parameters.personId
    ],
    requestBody: {
        parameterPath: {
            name: [
                "options",
                "name"
            ],
            userData: [
                "options",
                "userData"
            ]
        },
        mapper: __assign(__assign({}, Mappers.NameAndUserDataContract), { required: true })
    },
    responses: {
        200: {},
        default: {
            bodyMapper: Mappers.APIError
        }
    },
    serializer: serializer
};
var deleteFaceOperationSpec = {
    httpMethod: "DELETE",
    path: "largepersongroups/{largePersonGroupId}/persons/{personId}/persistedfaces/{persistedFaceId}",
    urlParameters: [
        Parameters.endpoint,
        Parameters.largePersonGroupId,
        Parameters.personId,
        Parameters.persistedFaceId
    ],
    responses: {
        200: {},
        default: {
            bodyMapper: Mappers.APIError
        }
    },
    serializer: serializer
};
var getFaceOperationSpec = {
    httpMethod: "GET",
    path: "largepersongroups/{largePersonGroupId}/persons/{personId}/persistedfaces/{persistedFaceId}",
    urlParameters: [
        Parameters.endpoint,
        Parameters.largePersonGroupId,
        Parameters.personId,
        Parameters.persistedFaceId
    ],
    responses: {
        200: {
            bodyMapper: Mappers.PersistedFace
        },
        default: {
            bodyMapper: Mappers.APIError
        }
    },
    serializer: serializer
};
var updateFaceOperationSpec = {
    httpMethod: "PATCH",
    path: "largepersongroups/{largePersonGroupId}/persons/{personId}/persistedfaces/{persistedFaceId}",
    urlParameters: [
        Parameters.endpoint,
        Parameters.largePersonGroupId,
        Parameters.personId,
        Parameters.persistedFaceId
    ],
    requestBody: {
        parameterPath: {
            userData: [
                "options",
                "userData"
            ]
        },
        mapper: __assign(__assign({}, Mappers.UpdateFaceRequest), { required: true })
    },
    responses: {
        200: {},
        default: {
            bodyMapper: Mappers.APIError
        }
    },
    serializer: serializer
};
var addFaceFromUrlOperationSpec = {
    httpMethod: "POST",
    path: "largepersongroups/{largePersonGroupId}/persons/{personId}/persistedfaces",
    urlParameters: [
        Parameters.endpoint,
        Parameters.largePersonGroupId,
        Parameters.personId
    ],
    queryParameters: [
        Parameters.userData,
        Parameters.targetFace,
        Parameters.detectionModel
    ],
    requestBody: {
        parameterPath: {
            url: "url"
        },
        mapper: __assign(__assign({}, Mappers.ImageUrl), { required: true })
    },
    responses: {
        200: {
            bodyMapper: Mappers.PersistedFace
        },
        default: {
            bodyMapper: Mappers.APIError
        }
    },
    serializer: serializer
};
var addFaceFromStreamOperationSpec = {
    httpMethod: "POST",
    path: "largepersongroups/{largePersonGroupId}/persons/{personId}/persistedfaces",
    urlParameters: [
        Parameters.endpoint,
        Parameters.largePersonGroupId,
        Parameters.personId
    ],
    queryParameters: [
        Parameters.userData,
        Parameters.targetFace,
        Parameters.detectionModel
    ],
    requestBody: {
        parameterPath: "image",
        mapper: {
            required: true,
            serializedName: "Image",
            type: {
                name: "Stream"
            }
        }
    },
    contentType: "application/octet-stream",
    responses: {
        200: {
            bodyMapper: Mappers.PersistedFace
        },
        default: {
            bodyMapper: Mappers.APIError
        }
    },
    serializer: serializer
};
//# sourceMappingURL=largePersonGroupPerson.js.map